import { createReducer } from "typesafe-actions";
import update from "immutability-helper";
import { actionConfirmation, actionWaiting, applyFilters, changeCheck, changeColumnVisibility, changeDirtyFilter, changeGlobalCheck, changeGlobalCheckAll, changePage, changePageSize, closeFilters, globalActionProgress, globalActionWaiting, openFilters, refreshing, register, resetFilters, setFilterFormError, sortColumn, unregister, } from "../actions/actions";
import { saveFromLS } from "../utils";
const initialState = {};
export const kptableReducer = createReducer(initialState)
    .handleAction(register, (state, action) => {
    if (state[action.payload.id]) {
        return state;
    }
    else {
        return update(state, {
            [action.payload.id]: { $set: action.payload.state },
        });
    }
})
    .handleAction(unregister, (state, action) => {
    if (state[action.payload]) {
        return update(state, { $unset: [action.payload] });
    }
    else {
        return state;
    }
})
    .handleAction(refreshing, (state, action) => update(state, {
    [action.payload.id]: {
        refreshing: { $set: action.payload.refresh },
        globalChecked: { $set: false },
        checked: { $set: {} },
        waiting: { $set: {} },
        confirmation: { $set: {} },
    },
}))
    .handleAction(changeGlobalCheck, (state, action) => update(state, {
    [action.payload.id]: {
        globalCheckedAll: { $set: false },
        globalChecked: { $set: action.payload.checked },
        checked: action.payload.data.reduce((prev, datum) => {
            prev[datum[action.payload.keyField]] = { $set: action.payload.checked };
            return prev;
            // tslint:disable-next-line:no-object-literal-type-assertion
        }, {}),
    },
}))
    .handleAction(changeGlobalCheckAll, (state, action) => update(state, {
    [action.payload.id]: {
        globalCheckedAll: { $set: action.payload.all },
    },
}))
    .handleAction(sortColumn, (state, action) => update(state, {
    [action.payload.id]: {
        sortingField: { $set: action.payload.sort },
        sortingDirection: { $set: action.payload.direction },
    },
}))
    .handleAction(changePage, (state, action) => update(state, {
    [action.payload.id]: {
        skip: { $set: action.payload.newPage },
    },
}))
    .handleAction(changePageSize, (state, action) => saveFromLS(action.payload.id, update(state, {
    [action.payload.id]: {
        top: { $set: action.payload.newPageSize },
    },
})))
    .handleAction(changeCheck, (state, action) => update(state, {
    [action.payload.id]: {
        checked: {
            [action.payload.key]: { $set: action.payload.value },
        },
        globalChecked: { $set: state[action.payload.id].globalChecked && action.payload.value },
    },
}))
    .handleAction(actionConfirmation, (state, action) => update(state, {
    [action.payload.id]: {
        confirmation: {
            [action.payload.datum[action.payload.keyField]]: { $set: action.payload.action ? action.payload : undefined },
        },
    },
}))
    .handleAction(actionWaiting, (state, action) => update(state, {
    [action.payload.id]: {
        waiting: {
            [action.payload.key]: { $set: action.payload.waiting },
        },
    },
}))
    .handleAction(changeColumnVisibility, (state, action) => update(state, {
    [action.payload.id]: {
        columnVisibility: {
            [action.payload.key]: { $set: action.payload.visibility },
        },
    },
}))
    .handleAction(globalActionWaiting, (state, action) => update(state, {
    [action.payload.id]: {
        globalWaiting: { $set: action.payload.waiting },
        globalShowProgress: { $set: action.payload.progress || false },
        globalProgress: { $set: 0 },
    },
}))
    .handleAction(globalActionProgress, (state, action) => update(state, {
    [action.payload.id]: {
        globalProgress: { $set: action.payload.progress },
    },
}))
    .handleAction(resetFilters, (state, action) => update(state, {
    [action.payload.id]: {
        filter: { $set: {} },
        dirtyFilters: { $set: {} },
    },
}))
    .handleAction(applyFilters, (state, action) => update(state, {
    [action.payload.id]: {
        filter: Object.keys(state[action.payload.id].dirtyFilters).reduce((prev, dk) => {
            prev[dk] = { $set: state[action.payload.id].dirtyFilters[dk] };
            return prev;
        }, {}),
        dirtyFilters: { $set: {} },
    },
}))
    .handleAction(changeDirtyFilter, (state, action) => update(state, {
    [action.payload.id]: {
        dirtyFilters: {
            [action.payload.name]: { $set: action.payload.value },
        },
    },
}))
    .handleAction(openFilters, (state, action) => update(state, {
    [action.payload.id]: {
        filtersOpened: { $set: true },
    },
}))
    .handleAction(setFilterFormError, (state, action) => update(state, {
    [action.payload.id]: {
        filterFormError: { $set: action.payload.hasError },
    },
}))
    .handleAction(closeFilters, (state, action) => update(state, {
    [action.payload.id]: {
        filtersOpened: { $set: false },
    },
}));
